import ModalsContainer from '@components/modals/modals-container';
import VerktoyList from '@components/verktoy-liste/finn-verktoy';
import { useBreadcrumb } from '@hooks/useBreadcrumb';
import { useGetResources } from '@hooks/useGetResources';
import { useAppSelector } from '@store';
import { getErrorLabel, hasPageHeader } from '@utils/verktoyContainer-utils';
import { useLocation } from 'react-router';

import Loader from '@helsenorge/designsystem-react/components/Loader';

import PageLoader from '@helsenorge/core-framework/page-loader';
import PageRoot from '@helsenorge/core-framework/pageroot';
import { getPath } from '@helsenorge/framework-utils/hn-page';

export const VerktoyListContainer = (): React.JSX.Element | null => {
  const location = useLocation();
  const resources = useGetResources();
  const breadcrumbLink = useBreadcrumb();
  const { error, isWaitingForAktivitetResponse } = useAppSelector(globalState => globalState.verktoy);

  const fullPath = `/${getPath()}${location.pathname}`;

  if (!resources) {
    return null;
  }
  return (
    <PageRoot
      hasPageHeader={hasPageHeader(location.pathname)}
      pageTitle={resources.entryPage_header}
      breadcrumbLink={breadcrumbLink}
      redirectTo={fullPath}
      enablePageviewTracking
      enableSurveys
    >
      <div className="verktoy__wrapper">
        <PageLoader inline resources={resources} error={error ? getErrorLabel(resources, error) : undefined}>
          {isWaitingForAktivitetResponse && <Loader />}
          <ModalsContainer />
          <VerktoyList />
        </PageLoader>
      </div>
    </PageRoot>
  );
};
